import { createClient, localStorageTokenStorage } from '@pnl/sdk';

const baseUrl = import.meta.env['VITE_API_URL'] ?? 'http://localhost:4000';

export const api = createClient({
  baseUrl,
  storage: localStorageTokenStorage('pnl_admin_'),
  onUnauthorized: () => {
    // O AuthGuard já reage ao estado vazio do store; redirect feito lá.
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
      window.location.href = '/login';
    }
  },
});
